module.exports = __webpack_public_path__ + "static/media/welcome-3-bg.69cb3fc8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/App/welcome-3-bg.jpg
// module id = 134
// module chunks = 0